import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import DiscreteGestureHandler from "./DiscreteGestureHandler";
import * as NodeManager from "./NodeManager";
import PressGestureHandler from "./PressGestureHandler";
import { TEST_MIN_IF_NOT_NAN, VEC_LEN_SQ } from "./utils";
var NativeViewGestureHandler = /*#__PURE__*/ function(PressGestureHandler) {
    "use strict";
    _inherits(NativeViewGestureHandler, PressGestureHandler);
    var _super = _create_super(NativeViewGestureHandler);
    function NativeViewGestureHandler() {
        _class_call_check(this, NativeViewGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(NativeViewGestureHandler, [
        {
            key: "isNative",
            get: function get() {
                return true;
            }
        },
        {
            key: "onRawEvent",
            value: function onRawEvent(ev) {
                var _this = this;
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "onRawEvent", this).call(this, ev);
                if (!ev.isFinal) {
                    // if (this.ref instanceof ScrollView) {
                    if (TEST_MIN_IF_NOT_NAN(VEC_LEN_SQ({
                        x: ev.deltaX,
                        y: ev.deltaY
                    }), 10)) {
                        // @ts-ignore FIXME(TS) config type
                        if (this.config.disallowInterruption) {
                            var gestures = Object.values(NodeManager.getNodes()).filter(function(gesture) {
                                var handlerTag = gesture.handlerTag, view = gesture.view, isGestureRunning = gesture.isGestureRunning;
                                return(// Check if this gesture isn't self
                                handlerTag !== _this.handlerTag && // Ensure the gesture needs to be cancelled
                                isGestureRunning && // ScrollView can cancel discrete gestures like taps and presses
                                _instanceof(gesture, DiscreteGestureHandler) && // Ensure a view exists and is a child of the current view
                                view && // @ts-ignore FIXME(TS) view type
                                _this.view.contains(view));
                            });
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                // Cancel all of the gestures that passed the filter
                                for(var _iterator = gestures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var gesture = _step.value;
                                    // TODO: Bacon: Send some cached event.
                                    gesture.forceInvalidate(ev);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    ]);
    return NativeViewGestureHandler;
}(PressGestureHandler);
export default NativeViewGestureHandler;
